import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import Cell from 'components/fulcrum/multiGrid/Cell'
import { Link } from 'react-router-dom'

import styles from './styles.scss'

const BodyCell = (props) => {
  const { content, to, ...rest } = props
  return (
    <Cell {...rest}>
      <Link to={to}>
        <div styleName='cell'>
          { content }
        </div>
      </Link>
    </Cell>
  )
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(BodyCell)
